const simpleEvents = function (object) {

    let events = {};

    object.on = function (eventName, callback) {
        if (callback) {
            let callbackList = events[eventName];
            if (!callbackList) {
                callbackList = events[eventName] = [];
            }
            if (callbackList.indexOf(callback) === -1) {
                callbackList.push(callback);
            }
        }
        return this;
    };

    object.off = function (eventName, callback) {
        const numArgs = arguments.length;
        if (!numArgs) {
            events = {};
        }
        else if (numArgs === 1) {
            delete events[eventName];
        }
        else if (callback) {
            const callbackList = events[eventName] || [];
            const idx = callbackList.indexOf(callback);
            if (idx > -1) {
                callbackList.splice(idx, 1);
            }
        }
        return this;
    };

    object.emit = function () {
        const args = [].slice.call(arguments);

        // Send event with name to listeners to the magic '*' event
        const allHandlers = events['*'];
        if (allHandlers && allHandlers.length) {
            args.unshift(object.widgetId);
            allHandlers
                .slice() // clone to prevent callbacks adding to the queue in mid-air
                .forEach(function (callback) {
                    callback.apply(null, args);
                });
            args.shift();
        }

        const eventName = args.shift();
        (events[eventName] || [])
            .slice() // clone to prevent callbacks adding to the queue in mid-air
            .forEach(function (callback) {
                callback.apply(null, args);
            });
        return this;
    };

};

// // Make  the `simpleEvents` factory itself also work as a pubsub singleton
// simpleEvents(simpleEvents);

export default simpleEvents;